var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"live"},[_c('Header',{attrs:{"active":'live'}}),_c('Video'),_c('div')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }